import gql from 'graphql-tag';

// Parent id for each child in idList. Callers pass limit as the chunk length so nothing is
// truncated; selectedIdList must stay absent, since the schema ignores idList when it is set.

export const GET_LINE_ITEM_PARENTS_BY_IDS = gql`
  query GET_LINE_ITEM_PARENTS_BY_IDS($idList: [ID!], $limit: Int!) {
    lineItems: lineItemsV5(
      filterOptions: { idList: $idList, skipCPEligibilityCalculation: true }
      paginationOptions: { limit: $limit }
    ) {
      edges {
        node {
          id
          campaign {
            id
          }
        }
      }
    }
  }
`;

export const GET_AD_PARENTS_BY_IDS = gql`
  query GET_AD_PARENTS_BY_IDS($idList: [ID!], $limit: Int!) {
    ads: adsV5(filterOptions: { idList: $idList }, paginationOptions: { limit: $limit }) {
      edges {
        node {
          id
          lineItem {
            id
          }
        }
      }
    }
  }
`;
